let scrollPosition = 0;

const quickAddBtns = document.querySelectorAll('.quick-add__submit');
const closeBtns = document.querySelectorAll('.quick-add-modal__toggle');
const quickAddModal = document.querySelectorAll('.quick-add-modal');

quickAddBtns.forEach(btn => {
    btn.addEventListener('click', function() {
        scrollPosition = window.scrollY;

        document.body.classList.add('quick-add-open');
        document.documentElement.style.setProperty('--page-top', `-${scrollPosition}px`);
    });
});

closeBtns.forEach(btn => {
    btn.addEventListener('click', function() {
        document.body.classList.remove('quick-add-open');

        document.documentElement.style.removeProperty('--page-top');
        window.scrollTo(0, scrollPosition);
    });
});

quickAddModal.forEach(modal => {
    modal.addEventListener('click', function(e) {
        if (e.target === modal) {
            document.body.classList.remove('quick-add-open');
            document.documentElement.style.removeProperty('--page-top');
            window.scrollTo(0, scrollPosition);
        }
    });
});

document.addEventListener('DOMContentLoaded', () => {
    window.upcartSubscribeCartUpdated(({ cart }) => {
        const countEl = document.querySelector('.cart-count-bubble > span');
        const itemCount = cart.items.reduce((total, item) => total + item.quantity, 0);
        document.querySelector('.cart-count-bubble').dataset.cartCount = itemCount;
        countEl.innerText = itemCount;
    });
})

// VARIANT SELECT LIST AB TEST

document.addEventListener('click', function(event) {

  const picker = event.target.closest(
    'details.product-variant-options__new'
  );

  const pickers = document.querySelectorAll(
    'details.product-variant-options__new'
  );

  pickers.forEach(function(item) {
    if (!picker || item !== picker) {
      item.open = false;
    }
  });

});